import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { AdpAdminHttpClient } from './adp-admin-http.client';
import { AdpAdminActions } from './adp-admin.store';
import type { AdpAdmin } from '../../../types';

@Injectable({ providedIn: 'root' })
export class AdpAdminEffects {
  private readonly adpAdminHttpClient = inject(AdpAdminHttpClient);
  private readonly actions$ = inject(Actions);

  public effect = createEffectFactory(AdpAdminActions, this.actions$);

  public fetchAdpAdmins$ = this.effect(AdpAdminActions.fetchCollection, () =>
    this.adpAdminHttpClient.fetch().pipe(
      map(this.filterAdmins),
      map(this.sortAdmins),
      map(admins => ({ data: admins })),
    ),
  );

  private filterAdmins(admins: Array<{ email: string | null }>): AdpAdmin[] {
    return <AdpAdmin[]>admins.filter(admin => admin.email !== null);
  }

  private sortAdmins(admins: AdpAdmin[]): AdpAdmin[] {
    return admins.sort((admin1, admin2) => admin1.fullName.localeCompare(admin2.fullName));
  }
}
